import Vue from 'vue';
import Vuex from 'vuex';

import settings from "../settings";

// modules
//import module from './modules/module';

// plugin
// import plugin from './plugins/';

const state = {
    home: settings.home,
    numbers1: settings.numbers1,
    numbers2: settings.numbers2,
    numbers3: settings.numbers3,
    clutch: settings.clutch,
    tabs: settings.tabs,
    careers: settings.careers
};


const getters = {};

const mutations = {};

const actions = {};

window.Vue || Vue.use(Vuex);

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules: {
        //module
    },
    plugins: [
        //plugin
    ]
});

export default store
